module.exports = __webpack_public_path__ + "static/media/Group40.519e8bbc.svg";